import styled from "styled-components";

export const SidebarDiv = styled.nav`
  min-width: var(--sidebarWidth);
  max-width: var(--sidebarWidth);
  width: 100%;
  user-select: none;
  border-right: var(--border);
  padding-top: var(--outerMargin);
  & + div {
    width: 100%;
    padding-top: var(--outerMargin);
    & > div {
      padding-left: var(--outerMargin);
    }
  }
  & hr {
    border-top: var(--border);
    border-bottom-width: 0;
  }
  & h2 {
    margin: 0 0 var(--gap) 0;
    font-size: 18px;
  }
  & h3 {
    margin: 0 0 5px 0;
    font-size: 16px;
  }
  & a.selected {
    font-weight: bold;
  }
  & ul {
    margin: 0 0 var(--gap) 0;
    padding: 0;
    list-style-type: none;
    & li {
      display: inline-block;
      white-space: nowrap;
      margin-right: 20px;
      &.selected {
        font-weight: bold;
      }
    }
  }
`;
